import moment from "moment";

// change format price 
export const formatPrice = (price) => {
    try {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    } catch (error) {
        return error;
    }
}

export const resolveVehicleImage = (image) => {
    if (!image) return 'images/car-header.png';
    if (image.startsWith('http') || image.startsWith('/') || image.startsWith('images/')) {
        return image;
    }
    return `images/car/${image}`;
}

const formatDateTimeValue = (date, time) => {
    const formatPart = (value, fmt) => {
        if (!value) return '';
        if (typeof value.format === 'function') return value.format(fmt);
        if (value.$d) return moment(value.$d).format(fmt);
        const parsed = moment(value);
        return parsed.isValid() ? parsed.format(fmt) : '';
    };
    return [formatPart(date, 'DD MMMM YYYY'), formatPart(time, 'HH:mm')].filter(Boolean).join(' ');
}

// text wa order
export const textWaOrder = (lang, car, date) => {
    try {
        if (lang === 'en') {
            if (car && date) return `Hello My Bali Rent Car, I want to order a ${car} on ${moment(date).format('DD MMMM YYYY')}. Thank you.`;
            else if (car) return `Hello My Bali Rent Car, I want to order a ${car}. Thank you.`;
            else return `Hello My Bali Rent Car, I want to order a car/motorcycle. Thank you.`;
        } else {
            if (car && date) return `Halo My Bali Rent Car, saya ingin memesan ${car} pada tanggal ${moment(date).format('DD MMMM YYYY')}. Terima kasih.`;
            else if (car) return `Halo My Bali Rent Car, saya ingin memesan ${car}. Terima kasih.`;
            else return `Halo My Bali Rent Car, saya ingin memesan mobil/motor. Terima kasih.`;
        }
    } catch (error) {
        return error;
    }
}

export const textWaCheckoutOrder = (lang, values) => {
    const startRent = formatDateTimeValue(values.pickUpDate, values.pickUpTime);
    const endRent = formatDateTimeValue(values.dropOffDate, values.dropOffTime);
    const statusLabel = values.statusLabel || values.status || '';

    if (lang === 'en') {
        return `Welcome to My Bali Rent Car ☺️🙏🏼

Please fill in so admin can respond quickly ⬇️

Full Name : ${values.name || ''}
Vehicle type rented: ${values.vehicle || ''}
Full address in Bali: ${values.addressBali || ''}
City as on ID card: ${values.cityKtp || ''}
Phone number: ${values.phoneNumber || ''}
instagram: ${values.instagram || ''}
Rental start date/time: ${startRent}
Rental end date/time: ${endRent}
Rental purpose: ${values.purpose || ''}
Status (Choose 1) : ${statusLabel}

Prices and terms click here⬇️
www.mybalirentcar.com

https://www.instagram.com/p/C5LEOR2ymVb/?igsh=czF5ZW43bHh6aGMy`;
    }

    return `Selamat Datang di My Bali Rent Car ☺️🙏🏼

Mohon di isi agar admin fast respon ⬇️

Nama Lengkap : ${values.name || ''}
Jenis Motor/mobil yang disewa: ${values.vehicle || ''}
Alamat Lengkap di Bali: ${values.addressBali || ''}
Kota sesuai KTP: ${values.cityKtp || ''}
No Telp: ${values.phoneNumber || ''}
instagram: ${values.instagram || ''}
Tanggal/Jam Mulai Sewa: ${startRent}
Tanggal/Jam Akhir Sewa: ${endRent}
Keperluan Sewa: ${values.purpose || ''}
Status (Pilih 1) : ${statusLabel}

Harga dan ketentuan klik di sini⬇️
www.mybalirentcar.com

https://www.instagram.com/p/C5LEOR2ymVb/?igsh=czF5ZW43bHh6aGMy`;
}